__turbopack_context__.v({
  "bar": "ImageTabBar-module-scss-module__GkKofW__bar",
  "caret": "ImageTabBar-module-scss-module__GkKofW__caret",
  "option": "ImageTabBar-module-scss-module__GkKofW__option",
  "optionList": "ImageTabBar-module-scss-module__GkKofW__optionList",
  "optionSelected": "ImageTabBar-module-scss-module__GkKofW__optionSelected",
  "positioner": "ImageTabBar-module-scss-module__GkKofW__positioner",
  "trigger": "ImageTabBar-module-scss-module__GkKofW__trigger",
  "triggerLabel": "ImageTabBar-module-scss-module__GkKofW__triggerLabel",
});
